import { useFeaturesContext } from "app/context/features.context";
import { useNavigatePath } from "app/hooks/navigation.hook";
import { isPremium } from "app/premium-catalog";
import { useGetPillowCategoryPath } from "services-hooks/hooks";
import { Category as CategoryType } from "services-hooks/types";
import { CategoryList } from "../category-list/category-list.component";
import { PodcastList } from "../podcats-list/podcast-list.component";
import { StationsList } from "../stations-list/stations-list.component";
import styles from "./category.module.scss";

interface CategoryProps {
  category: CategoryType;
  podcast?: boolean;
  showDetailsOnClick?: boolean;
  className?: string;
  items: CategoryType[];
  showStationNames?: boolean;
}
export const Category: React.FC<CategoryProps> = ({
  category,
  showDetailsOnClick,
  className,
  showStationNames = false,
  items,
}) => {
  const navigatePath = useNavigatePath();
  const { data, isLoading, fetchNextPage } = useGetPillowCategoryPath(
    category.permalink!,
    {
      pageSize: 20,
    }
  );

  const { isCarMode } = useFeaturesContext();

  const mappedPages =
    data?.pages.reduce((acc, current) => {
      if (current.data.body?.content) {
        acc = [...acc, ...current.data.body.content];
      }
      return acc;
    }, [] as CategoryType[]) || [];
  const stations = items.filter((category) => category.type === "radio");
  const podcasts = items.filter((category) => category.type === "podcast");
  const categories = items.filter((category) => category.type === "category");

  return (
    <>
      {podcasts.length > 0 && (
        <div className={styles.stations_wrapper}>
          <PodcastList
            items={podcasts}
            label={category.name!}
            loading={false}
            className={className}
          />
        </div>
      )}
      {stations.length > 0 && (
        <div className={styles.stations_wrapper}>
          <StationsList
            items={stations}
            label={category.name!}
            loading={false}
            showDetailsOnClick={showDetailsOnClick}
            className={className}
            showStationNames={showStationNames}
          />
        </div>
      )}
      {categories.length > 0 && (
        <div className={styles.categories_wrapper}>
          <CategoryList
            label={category.name!}
            items={categories}
            loading={false}
            isPremium={isPremium(category.permalink!)}
          />
        </div>
      )}
    </>
  );
};
